module.exports = __webpack_public_path__ + "img/CY.97e58431.png";